import { Button, Layout } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningToolPanel extends Layout {
    buttonDispatch: Button;
    buttonDriverEvent: Button;
    buttonEquipManageAssign: Button;
    buttonFeasibility: Button;
    buttonFindNear: Button;
    buttonHold: Button;
    buttonLink: Button;
    buttonLoadMatch: Button;
    buttonManageAssign: Button;
    buttonSeatDriver: Button;
    buttonSeatTractor: Button;
    buttonSendEmail: Button;
    buttonTonu: Button;
    buttonUnassign: Button;
    buttonUpdateFields: Button;
    buttonViewMovements: Button;
    buttonYsplit: Button;
    buttonZmit: Button;
    buttonCancelSentLoad: Button;
}
